import React from "react";
import {defaults} from './userState';

export default React.createContext(defaults);
